export default __webpack_public_path__ + "static/tos-1.3b.576d.html";